import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

interface JiraTicketResponse {
  id: string;
  key: string;
  fields: {
    summary: string;
    status: {
      name: string;
      statusCategory: {
        name: string;
        colorName: string;
      };
    };
    assignee?: {
      displayName: string;
      avatarUrls: {
        "48x48": string;
      };
    };
    created: string;
    updated: string;
    description?: string;
  };
}

const useJiraTicket = (ticketKey: string, enabled: boolean = true) => {
  return useQuery<JiraTicketResponse, Error>(
    ["jiraTicket", ticketKey],
    () => {
      return servicesUtils.getService<JiraTicketResponse>("/jira_ticket/", {
        ticket_key: ticketKey,
      });
    },
    {
      enabled: enabled && !!ticketKey,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      retry: 1,
    }
  );
};

export default useJiraTicket;
export type { JiraTicketResponse };
